"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logoutUser = exports.loginUser = void 0;
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("utils/constants");
const error_response_1 = require("utils/error-response");
const auth_types_1 = require("pages/auth/auth.types");
const getFromLocalStorage = {
    token: () => {
        const token = localStorage.getItem(constants_1.localStorageKey.token);
        if (token)
            return token;
        return '';
    }
};
const loginUser = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/user/auth/login';
    const ip = String(process.env.IP_PC);
    try {
        let res = { data: { IPv4: '' } };
        if (ip == '0.0.0.0')
            res = yield axios_1.default.get('https://geolocation-db.com/json/');
        else
            res = { data: { IPv4: ip } };
        const args = Object.assign(Object.assign({}, arg), { ip: res.data.IPv4, apps_type: '82073067-5f6f-4acd-87b5-c820b2e5eef7' });
        const { data } = yield axios_1.default.post(url, args);
        return {
            isError: false,
            errorMessage: '',
            errorCode: 0,
            data: {
                isAuthenticated: data.data.isAuthenticated,
                token: data.data.token,
                userData: data.data.userData,
                defaultPassword: data.data.defaultPassword,
            },
        };
    }
    catch (e) {
        const response = (0, error_response_1.errorResponse)(e);
        return Object.assign(Object.assign({}, response), { data: {
                isAuthenticated: false,
                token: '',
                userData: auth_types_1.initialUserProfile,
                defaultPassword: false,
            } });
    }
});
exports.loginUser = loginUser;
const logoutUser = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/user/auth/logout';
    try {
        const args = { id: arg.id };
        const { data } = yield axios_1.default.post(url, args, {
            headers: {
                'X-User-Token': getFromLocalStorage.token()
            }
        });
        return {
            isError: false,
            errorMessage: '',
            errorCode: 0,
            data: {
                isAuthenticated: data.data.isAuthenticated,
                token: data.data.token,
                userData: data.data.userData,
                defaultPassword: data.data.defaultPassword,
            },
        };
    }
    catch (e) {
        const response = (0, error_response_1.errorResponse)(e);
        return Object.assign(Object.assign({}, response), { data: {
                isAuthenticated: false,
                token: '',
                userData: auth_types_1.initialUserProfile,
                defaultPassword: false,
            } });
    }
});
exports.logoutUser = logoutUser;
